module.exports = __webpack_public_path__ + "static/media/logo.aa4b9347.png";